import { ActionViewModel } from '../models/viewModels/ActionViewModel';
import { OutputViewModel } from '../models/viewModels/OutputViewModel';
import { BuilderContentType } from '../tabs/content/BuilderContentType';
const enteringCustomActions = '$enteringCustomActions';
export class ActionContentService {
    static getInstance() {
        if (!ActionContentService.instance) {
            ActionContentService.instance = new ActionContentService();
        }
        return ActionContentService.instance;
    }
    constructor() {
        this.isEditingActionContent = false;
    }
    setIsEditingActionContent(value) {
        this.isEditingActionContent = value;
    }
    getIsEditingActionContent() {
        return this.isEditingActionContent;
    }
    setStateAction(state, type, typeOfAction, settings) {
        const actionToAdd = new ActionViewModel({
            type,
            $title: type,
            settings,
        });
        if (typeOfAction === enteringCustomActions) {
            state.$enteringCustomActions = state.$enteringCustomActions.concat(actionToAdd);
        }
        else {
            state.$leavingCustomActions = state.$leavingCustomActions.concat(actionToAdd);
        }
    }
    addOutputConditions(outputConditions, contentAction) {
        return this.addNecessaryOutputConditions(outputConditions, contentAction);
    }
    removeUnnecessaryOutputConditions(outputConditions, contentAction) {
        return outputConditions.filter(outputCondition => this.filterNecessaryOutputConditions(outputCondition, contentAction));
    }
    addNecessaryOutputConditions(outputConditions, contentAction) {
        const contentOptions = contentAction.action.$cardContent.document.content.options.map(option => option.text);
        const conditions = outputConditions.filter(opt => !opt.$isBuilderDefaultOutput).map(outputCondition => outputCondition.conditions);
        const conditionsFlat = conditions.reduce((acc, val) => acc.concat(val), []);
        const values = conditionsFlat.map(condition => condition.values);
        const valuesFlat = values.reduce((acc, val) => acc.concat(val), []);
        const optionsToAdd = contentOptions.filter(option => !valuesFlat.includes(option));
        let outputs = [];
        optionsToAdd.forEach(element => {
            outputs = outputs.concat(OutputViewModel.createFromContentOption(contentAction.action.$id, element));
        });
        const optionsToRemove = valuesFlat.filter(value => !contentOptions.includes(value));
        const finalOutputConditions = outputConditions.concat(outputs).filter(otp => otp.conditions.some(condition => condition.values.some(value => !optionsToRemove.includes(value))));
        return finalOutputConditions;
    }
    filterNecessaryOutputConditions(outputCondition, contentAction) {
        if (outputCondition.$contentId != contentAction.action.$id) {
            return true;
        }
        const contentOptions = contentAction.action.$cardContent.document.content.options.map(option => option.text);
        const values = outputCondition.conditions.map(condition => condition.values);
        const valuesFlat = values.reduce((acc, val) => acc.concat(val), []);
        return contentOptions.some(option => valuesFlat.includes(option));
    }
    getAllOutputConditions(contentAction, conditionOutputs) {
        if (contentAction.action?.$typeOfContent
            && (contentAction.action.$typeOfContent === BuilderContentType.Select
                || contentAction.action.$typeOfContent === BuilderContentType.SelectImmediate)) {
            return this.addOutputConditions(conditionOutputs, contentAction);
        }
    }
}
